import { ArrowBackIos } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";
import React from "react";

const BottomBarDrawer = ({ setDrawerOpen, setShowLangEditor }) => {
  return (
    <React.Fragment>
      <Stack
        width="100%"
        alignItems="center"
        paddingLeft={"1em"}
        direction="row-reverse"
        justifyContent="space-between"
        bgcolor={themeColors.ColorPrimary}
        sx={{ color: themeColors.ColorSecondary, minHeight: "40px" }}
      >
        <h2 style={{ textAlign: "center", flex: 1, marginRight: "2em" }}>
          {FindLangKey("personalization-drawer-navbar-title")}
        </h2>
        <IconButton
          onClick={() => {
            setDrawerOpen && setDrawerOpen(false);
            setShowLangEditor && setShowLangEditor(false);
          }}
        >
          <ArrowBackIos
            sx={{
              color: themeColors.ColorSecondary,
              fontSize: "1.3em !important",
            }}
          />
        </IconButton>
      </Stack>
    </React.Fragment>
  );
};

export default BottomBarDrawer;
